import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const Activities = () => {
  useEffect(() => {
    document.title = "Activities - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />

      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>About Us</li>
          <li>Activities</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Activities</h1>
            </div>
          </div>

          <div className="row facilities">
            {/* Arts and Crafts */}
            <div className="col-12">
              <h3 className="subhead">Arts And Crafts Club</h3>
              <div className="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Artsimg.jpg"
                    alt="Arts and Crafts"
                  />
                </LazyLoad>
              </div>
              <p className="first-letter">
                This club was formed with the idea of moulding the students to
                have interest in colours, craft etc. We have classes for fabric
                painting, glass painting, oil painting, pencil drawing, pottery
                painting etc.
              </p>
            </div>

            <hr />

            {/* Sports Club */}
            <div className="col-12">
              <h3 className="subhead">Sports Club</h3>
              <div className="facilities-img right-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Sportsimg.jpg"
                    alt="Sports"
                  />
                </LazyLoad>
              </div>
              <p className="first-letter">
                Indoor games: Chess, Table Tennis, Carrom. Outdoor games:
                Volleyball, Football, Badminton, Kho Kho, Athletics. Others:
                Abacus and Vedic Maths.
              </p>
            </div>

            <hr />

            {/* House Wise Programmes */}
            <div className="col-12">
              <h3 className="subhead">House Wise Programmes</h3>
              <div className="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/competitionsimg.jpg"
                    alt="House Programmes"
                  />
                </LazyLoad>
              </div>
              <p className="first-letters">
                Students are divided into four houses: Emerald, Topaz, Ruby and
                Sapphire. House-wise competitions help develop unity,
                responsibility and competitive spirit.
              </p>
            </div>

            <hr />

            {/* Speakers Forum */}
            <div className="col-12">
              <h3 className="subhead">Speakers Forum</h3>
              <div className="facilities-img right-block">
                <LazyLoad>
                  {/*<img
                  className="img-fluid"
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/SpeakersForumimg.jpg"
                  alt="Speakers Forum"
                   />*/}
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Images/SpeakersForum.jpg"
                    alt="Speakers Forum"
                  />
                </LazyLoad>
              </div>
              <p className="first-letter">
                This forum assists students in extempore speaking and sharing
                ideas confidently.
              </p>
            </div>

            <hr />

            {/* Karate & Yoga */}
            <div className="col-12">
              <h3 className="subhead">Karate & Yoga</h3>
              <div className="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Karateimg.jpg"
                    alt="Karate and Yoga"
                  />
                </LazyLoad>
              </div>
              <p className="first-letters">
                Yoga enhances concentration and well-being, while Karate equips
                students with self-defense skills under trained instructors.
              </p>
            </div>

            <hr />

            {/* Nature Club */}
            <div className="col-12">
              <h3 className="subhead">Nature Club</h3>
              <div className="facilities-img1 right-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/NatureClubimg.jpg"
                    alt="Nature Club"
                  />
                </LazyLoad>
              </div>
              <p className="first-letter">
                The Nature Club promotes love and care for Mother Earth through
                cleanliness and green campus activities.
              </p>
            </div>

            <hr />

            {/* School Band */}
            <div className="col-12">
              <h3 className="subhead">School Band</h3>
              <div className="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/BandSetimg.jpg"
                    alt="School Band"
                  />
                </LazyLoad>
              </div>
              <p className="first-letter">
                The school band consists of 33 students trained by a
                professional band master.
              </p>
            </div>

            <hr />

            {/* Dance & Music */}
            <div className="col-12">
              <h3 className="subhead">Dance and Music Clubs</h3>
              <div className="facilities-img right-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/MusicClubsimg.jpg"
                    alt="Music Club"
                  />
                </LazyLoad>
              </div>
              <p className="first-letter">
                At SPCS, you're promoting a holistic approach to education by
                encouraging students to participate in music and dance
                activities. This not only enhances their creativity but also
                improves their physical and mental well being. Music and dance
                can boost body function, increase flexibility, and reduce
                stress.
              </p>
            </div>

            <hr />

            {/* Robotics */}
            <div className="col-12">
              <h3 className="subhead">Robotics</h3>
              <div className="facilities-img1 left-block">
                <LazyLoad>
                  <img
                    className="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/robotics.jpg"
                    alt="Robotics"
                  />
                </LazyLoad>
              </div>
              <p className="first-letter">
                The robotics lab at SPCS offers a hands-on environment wherein
                students cultivate critical thinking, problem solving, and
                collaboration skills. This facility fosters an atmosphere that
                encourages critical thought, efficient work practices, and the
                development of essential skills requisite for STEM (Science,
                Technology, Engineering, and Mathematics) fields and other
                disciplines.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Activities;
